import { atom } from 'recoil';
import { IEndereco } from '../../commons/types/usuatios';


export const enderecosAtom = atom<IEndereco[]>({
  key: 'enderecos', 
  default: [] as IEndereco[],
}); 
